import * as React from 'react';
import { Header } from 'grommet';
/* import Socials from './Socials';
 */
import config from '../../config';
import { motion } from 'framer-motion';

const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
      staggerChildren: 1,
    },
  },
};

const mainTitle = {
  hidden: { y: -20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      delay: 0,
      duration: 1,
    },
  },
};

const subTitle = {
  hidden: { y: -20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      delay: 1,
      duration: 1,
    },
  },
};

const stackList = {
  hidden: { opacity: 0 },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      delay: 7,
      duration: 2,
    },
  },
};

const TitleCard = () => (
  <Header id="headerId">
    <motion.ul
      /*       className="container"
       */ variants={container}
      initial="hidden"
      animate="visible"
    >
      {/*       {headerArray.map(headerObject => (
        <motion.li key={headerObject} variants={item}>
          {headerObject}
        </motion.li>
      ))} */}

      <motion.li key="maintitleheader" variants={mainTitle}>
        <h1 align="center">
          {config.heading} {config.heading2}
        </h1>
      </motion.li>
      <motion.li key="subtitleheader" variants={subTitle}>
        <h2 style={{ margin: '1em' }} align="center">
          {config.subHeading}
        </h2>
      </motion.li>
      {/*       <motion.li key="socials" variants={subTitle}>
        <Socials />
      </motion.li> */}
    </motion.ul>
  </Header>
);

export default TitleCard;
